export const company = {
  brand: 'Tecnvirons',
  email: 'ai@tecnvi-ai.com',
  offices: [
    {
      key: 'us',
      label: 'Headquarters — Springfield, Illinois',
      city: 'Springfield, Illinois',
      legalName: 'Tecnvirons LLC',
      address: '2501 Chatham Rd, Suite R, Springfield, IL 62704, USA',
      hours: 'Mon–Fri, 9:00–18:00 CT',
      phone: '+1 (309) 226-9909',
      mapQuery: '2501 Chatham Rd, Springfield, IL 62704',
    },
    {
      key: 'in',
      label: 'India Office — Pune',
      city: 'Pune',
      legalName: 'Tecnvirons Pvt Ltd',
      address: 'F-4, Angel Apartment, Road 6, Kalyani Nagar, Pune 411006, India',
      hours: 'Mon–Fri, 9:30–18:30 IST',
      phone: '+91 93711 59100',
      mapQuery: 'Kalyani Nagar, Pune 411006',
    },
  ],
  whatsapp: '+91 88288 25499',
  whatsappLink: 'https://wa.me/918828825499',
  social: {
    linkedin: 'https://linkedin.com/in/tecnvirons',
    twitter: 'https://x.com/Tecnvirons',
    facebook: 'https://facebook.com/profile.php?id=61574879993378',
    instagram: 'https://instagram.com/tecnviai/',
  },
};
